import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles.css';

const Login = () => {
  const [formData, setFormData] = useState({ employee_code: '', password: '' });
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      // const response = await axios.post('http://127.0.0.1:8000/attendence/api/v1/login/', formData);
      const response = await axios.post('https://attend.teamhalt.com/attendence/api/v1/login/', formData);

      const { user, access, refresh } = response.data;

      localStorage.setItem('id', user.id);
      localStorage.setItem('employee_code', user.employee_code);
      localStorage.setItem('name', user.first_name + ' ' + user.last_name);
      localStorage.setItem('accessToken', access);
      localStorage.setItem('refreshToken', refresh);
      localStorage.setItem('assignedRole', JSON.stringify(user.role)); 

      console.log("AccessToken stored in local storage:", localStorage.getItem('accessToken'));

      if (['admin', 'manager', 'team_lead'].includes(user.role.name)) {
        navigate('/admin-manager-lead-dashboard');
      } else if (user.role.name === 'employee') {
        navigate('/user-dashboard');
      }
    } catch (error) {
      console.error('Login error:', error.response ? error.response.data : error);
      setError('Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

   const refreshAccessToken = async () => {
     try {
       const refreshToken = localStorage.getItem('refreshToken');
       // const response = await axios.post('http://127.0.0.1:8000/attendence/api/v1/login/', {
         const response = await axios.post('https://attend.teamhalt.com/attendence/api/v1/login/', {
         employee_code: localStorage.getItem('employee_code'),
         password: localStorage.getItem('password')
       }, {
         headers: {
           'Authorization': `Bearer ${refreshToken}`
         }
       });
  
       const { access } = response.data;
       localStorage.setItem('accessToken', access);
  
       if (['admin', 'manager', 'team_lead'].includes(JSON.parse(localStorage.getItem('assignedRole')).name)) {
         navigate('/admin-manager-lead-dashboard');
       } else if (JSON.parse(localStorage.getItem('assignedRole')).name === 'employee') {
         navigate('/user-dashboard');
       }
     } catch (error) {
       console.error('Error refreshing access token:', error.response ? error.response.data : error);
       localStorage.removeItem('accessToken');
       localStorage.removeItem('refreshToken');
     }
   };

   useEffect(() => {
     const accessToken = localStorage.getItem('accessToken');
     const refreshToken = localStorage.getItem('refreshToken');
     const employeeCode = localStorage.getItem('employee_code');

     if (accessToken && refreshToken && employeeCode) {
       if (accessToken) {
         if (['admin', 'manager', 'team_lead'].includes(JSON.parse(localStorage.getItem('assignedRole')).name)) {
           navigate('/admin-manager-lead-dashboard');
         } else if (JSON.parse(localStorage.getItem('assignedRole')).name === 'employee') {
           navigate('/user-dashboard');
         }
       } else {
         refreshAccessToken();
       }
     }
   }, []);

  return (
    <div className="auth-wrapper">
      <div className="auth-left-section">
        <div className="auth-header">
          <div className="auth-brand-logo">
            <img src="/Teamhalt.png" alt="TeamHalt" className="logo-icon" />
            <span className="logo-text">TeamHalt</span>
          </div>
        </div>
        
        <div className="auth-brand-content">
          <h1>Attendance Management System</h1>
          <p>Track your work hours, manage leaves, and boost productivity with our comprehensive employee attendance solution.</p>
          <div className="auth-features">
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Real-time Attendance Tracking</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Easy Leave Management</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Live Location Tracking</span>
            </div>
          </div>
        </div>
        
        <div className="auth-footer">
          <Link to="/privacy-policy" className="privacy-link">Privacy Policy</Link>
          <p className="copyright">© 2026 TeamHalt. All rights reserved.</p>
        </div>
      </div>
      
      <div className="auth-right-section">
        <div className="auth-card">
          <div className="auth-header-form">
            <h2>Welcome Back</h2>
            <p>Please enter your credentials to login</p>
          </div>
          
          <form onSubmit={handleSubmit} className="auth-form-container">
            <div className="form-group">
              <label htmlFor="employee_code">Employee Code</label>
              <div className="input-wrapper">
                {/* <span className="input-icon">👤</span> */}
                <input
                  type="text" 
                  id="employee_code"
                  name="employee_code"
                  placeholder="Enter your employee code"
                  value={formData.employee_code}
                  onChange={handleChange}
                  required
                  autoComplete="username"
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                {/* <span className="input-icon">🔒</span> */}
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? '👁' : '👁‍🗨'}
                </button>
              </div>
            </div>
            
            {error && (
              <div className="auth-error">
                <span className="error-icon">⚠</span>
                <span>{error}</span>
              </div>
            )}
            
            <button 
              type="submit" 
              className="auth-button"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="loading-spinner"></span>
              ) : (
                'Login'
              )}
            </button>
          </form>
          
          <div className="auth-footer-form">
            <Link to="/forgot-password" className="forgot-password-link">
              Forgot Password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
